export default __webpack_public_path__ + "static/media/mbfcTower2.jpg?.00697f12";